import { AsyncSearch } from '@global-engineering-shared/gweb-material-lab';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { IFormattedSearch } from 'components/Header';
import SearchOption from 'components/Header/components/SearchBar/SearchOption';
import { handleSearch } from 'components/Header/components/SearchBar/utils/handleSearch';
import { handleSelection } from 'components/Header/components/SearchBar/utils/handleSelection';
import { handleShowAllSearchResults } from 'components/Header/components/SearchBar/utils/handleShowAllSearchResults';
import { Frame, PageResponse } from 'features/Frames/types';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { SEARCH_RESULTS_LIMIT } from 'utils/defaults';
import { FRAMES_API_URL } from 'utils/environmentVariables';

import useStyles from './SearchBar.styles';

const SearchBar = () => {
  const [inputValue, setInputValue] = useState('');
  const [searchResults, setSearchResults] = useState<Frame[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const { fetchDataWithToken, isDataLoading } = useFetchWithToken();

  useEffect(() => {
    if (inputValue) {
      const url = `${FRAMES_API_URL}/search?searchTerm=${inputValue}`;
      fetchDataWithToken<PageResponse>(url, (pageResponse) => setSearchResults(pageResponse.items));
    }
  }, [inputValue]);

  useEffect(() => {
    if (!isDataLoading) {
      setIsLoading(isDataLoading);
    }
  }, [isDataLoading]);

  return (
    <div className={classes.root}>
      <AsyncSearch
        searchTerm=""
        searchedData={searchResults}
        SearchOption={(props) => <SearchOption {...props} />}
        setSearchTerm={() => ''}
        placeholder="Search"
        handleSearch={(newValue) => handleSearch(inputValue, setInputValue, newValue)}
        handleSelection={(option: IFormattedSearch) => handleSelection(navigate, option)}
        searchResultsLimit={SEARCH_RESULTS_LIMIT}
        debounceTime={350}
        searching={isLoading}
        noResultsText={`No results found for "${inputValue}"`}
        showAllSearchResults={() => handleShowAllSearchResults(navigate, inputValue, searchResults)}
      />
    </div>
  );
};

export default SearchBar;
